var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from "dayjs";
import * as Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import * as React from "react";
import { Field, useForm } from "react-final-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button } from "@components/student/Button";
import { LabelInput } from "@components/ui/LabelInput";
import { composeValidators, emailValidator, phoneNumberValidator, required, } from "@utils/validators";
import { ConcertRows } from "../ConcertRows";
import * as s from "./ConcertUserInfo.sss";
import { Loader } from "@/components/ui/Loader";
import { useConcertRowsQuery, } from "@/graphql";
dayjs.locale("uk");
export const ConcertUserInfo = ({ concertId, title, time, }) => {
    var _a;
    const { t } = useTranslation();
    const form = useForm();
    const [refetchLoading, setRefetchLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const { data, loading, refetch } = useConcertRowsQuery({
        variables: {
            concertId: Number(concertId),
        },
    });
    const { values } = form.getState();
    React.useEffect(() => {
        const sessionid = uuidv4();
        Cookies.set("sessionid", sessionid);
    }, []);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setErrorMessage(null);
        setRefetchLoading(true);
        const randomDelay = Math.floor(Math.random() * 5000) + 1000;
        yield new Promise(resolve => setTimeout(resolve, randomDelay));
        const { data: refetchData } = yield refetch();
        const areUnavailablePlacesSelected = values.placeIds.some(placeId => {
            const concertRow = refetchData === null || refetchData === void 0 ? void 0 : refetchData.concertRows.find(row => row.rowPlaces.some(place => place.id === placeId));
            return (concertRow &&
                concertRow.rowPlaces.some(place => place.id === placeId && !place.isAvailable));
        });
        setRefetchLoading(false);
        if (!areUnavailablePlacesSelected) {
            form.submit();
        }
        else {
            toast("Обрані місця вже не доступні!", {
                type: "error",
            });
        }
    });
    if (loading || !data) {
        return React.createElement(Loader, null);
    }
    return (React.createElement("form", { className: s.root, onSubmit: handleSubmit },
        React.createElement("div", { className: s.concertTitle }, title),
        React.createElement("div", { className: s.concertSubTitle }, dayjs(time).format("DD MMMM HH:mm")),
        React.createElement("div", { className: s.userInfo },
            React.createElement("div", { className: s.title }, t("site~Введіть ваші контактні дані")),
            React.createElement("div", null,
                React.createElement(Field, { name: "email", validate: composeValidators([required, emailValidator]), render: ({ input, meta }) => (React.createElement(React.Fragment, null,
                        setErrorMessage((meta.touched && meta.error) || meta.submitError),
                        React.createElement(LabelInput, Object.assign({ className: s.input, placeholder: t("site~Вкажіть ваш email*"), autoComplete: "email" }, input, { error: (meta.touched && meta.error) || meta.submitError })))) }),
                React.createElement(Field, { name: "phoneNumber", validate: composeValidators([required, phoneNumberValidator]), render: ({ input, meta }) => (React.createElement(React.Fragment, null,
                        setErrorMessage((meta.touched && meta.error) || meta.submitError),
                        React.createElement(LabelInput, Object.assign({ className: s.input, placeholder: t("site~Ваш номер телефону*"), autoComplete: "tel" }, input, { error: (meta.touched && meta.error) || meta.submitError })))) }))),
        React.createElement(ConcertRows, { data: data, refetch: refetch, concertId: concertId }),
        refetchLoading && (React.createElement("div", { className: s.loader },
            React.createElement("span", { "data-view-component": "true", style: { display: "flex", justifyContent: "center" } },
                " ",
                React.createElement("svg", { style: {
                        boxSizing: "content-box",
                        color: "var(--color-icon-primary)",
                    }, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", "data-view-component": "true", className: s.animRotate },
                    React.createElement("circle", { cx: "8", cy: "8", r: "7", stroke: "currentColor", strokeOpacity: "0.25", strokeWidth: "2", vectorEffect: "non-scaling-stroke", fill: "none" }),
                    React.createElement("path", { d: "M15 8a7.002 7.002 0 00-7-7", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", vectorEffect: "non-scaling-stroke" }))))),
        errorMessage ? (React.createElement("div", { className: s.errorMessage },
            t("site~Введіть ваші контактні дані."),
            " ",
            errorMessage,
            " ")) : null,
        React.createElement(Button, { className: s.submitButton, type: "submit", disabled: !((_a = values.placeIds) === null || _a === void 0 ? void 0 : _a.length) ||
                !values.email ||
                !values.phoneNumber ||
                refetchLoading }, t("site~Придбати"))));
};
